// src/admin/AdminDeposits.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DepositTool from './DepositTool';
import AdminDepositTasks from './AdminDepositTasks';
import DepositHistory from './DepositHistory';

export default function AdminDeposits() {
  const [tab, setTab] = useState('actions'); // 'actions' | 'tasks' | 'history'
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.topbar}>
        <button onClick={() => navigate('/dashboard')} style={styles.backButton}>
          ← Back to Dashboard
        </button>
      </div>

      <h1 style={styles.h1}>Admin • Deposits</h1>

      <div style={styles.tabs}>
        <button
          onClick={() => setTab('actions')}
          style={{ ...styles.tab, ...(tab === 'actions' ? styles.tabActive : {}) }}
        >
          Hold Actions
        </button>
        <button
          onClick={() => setTab('tasks')}
          style={{ ...styles.tab, ...(tab === 'tasks' ? styles.tabActive : {}) }}
        >
          Tasks
        </button>
        <button
          onClick={() => setTab('history')}
          style={{ ...styles.tab, ...(tab === 'history' ? styles.tabActive : {}) }}
        >
          History
        </button>
      </div>

      <div style={styles.panel}>
        {tab === 'actions' && <DepositTool />}
        {tab === 'tasks' && <AdminDepositTasks />}
        {tab === 'history' && <DepositHistory />}
      </div>
    </div>
  );
}

const styles = {
  container: { padding: '1.25rem', maxWidth: 1100, margin: '0 auto' },
  topbar: { display: 'flex', justifyContent: 'flex-start', marginBottom: 8 },
  backButton: {
    backgroundColor: '#eeeeee',
    border: '1px solid #ccc',
    padding: '0.5rem 1rem',
    borderRadius: 6,
    cursor: 'pointer',
    fontWeight: 500,
    marginBottom: '2rem',
  },
  h1: { margin: '8px 0 0 0', fontSize: '1.25rem', fontWeight: 700, color: '#065f46' },
  tabs: { display: 'flex', gap: 8, marginTop: 12, marginBottom: 12 },
  tab: {
    padding: '0.5rem 0.75rem',
    borderRadius: 8,
    border: '1px solid #d1d5db',
    background: '#fff',
    cursor: 'pointer',
    fontWeight: 600,
  },
  tabActive: { background: '#ecfdf5', borderColor: '#10b981', color: '#065f46' },
panel: { border: '1px solid #e5e7eb', borderRadius: 10, background: '#fff' },
};
